module.exports = __webpack_public_path__ + "media/images/slides/gravelines-de0545a6940f6a5c2c73fc9c50d343ac.jpg";